import MiniLazyload from 'minilazyload';

const lazyLoadImages = () => {
    new MiniLazyload({
    }, '.js-lazy', MiniLazyload.IGNORE_NATIVE_LAZYLOAD);
};

export default lazyLoadImages;